<!--components\Carruseles\CarruselPromocional.vue-->
<template>
  <!-- Carrusel Desktop -->
  <Carrusel 
    v-if="!isMobile"
    :data="props.imagenesPromocionales.desktop"
    :itemsPorPagina="1"
    :ClaseSlide="ClaseSlide" 
    :autoplay="true"
    :autoplayInterval="5000"
    :bucle="true"
    
    :habilitarBotonesNav="true"
    customBotonesNavClass="p-1 md:p-1 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
    customIconClass="text-current w-4 h-4" 
    customPrevPosition="left-[0.4rem]"
    customNextPosition="right-[0.4rem]" 
    
    :motrarPuntos="true"  
    PadreDotClass="absolute bottom-0 left-1/2 transform -translate-x-1/2"
    customDotClass="w-3 h-3"
    customActiveDotClass="bg-ROJO_LEON w-6" 
    customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2">
    
    <template #contenido="{ items }">
      <template v-for="(panel, index) in items" :key="index">
        <PanelImagenMasAnchor 
          :data="panel"
        />
      </template>
    </template>
  </Carrusel>

  <!-- Carrusel Mobile -->
  <Carrusel 
    v-else
    :data="props.imagenesPromocionales.mobile"
    :itemsPorPagina="1"
    :ClaseSlide="ClaseSlide" 
    :autoplay="true" 
    :autoplayInterval="5000"
    :bucle="true"

    :habilitarBotonesNav="false"
    customBotonesNavClass="p-1 md:p-1 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
    customIconClass="text-current w-4 h-4" 
    customPrevPosition="left-[0.4rem]"
    customNextPosition="right-[0.4rem]" 

    :motrarPuntos="true"
    PadreDotClass="absolute bottom-0 left-1/2 transform -translate-x-1/2"
    customDotClass="w-2 h-2"
    customActiveDotClass="bg-ROJO_LEON w-6" 
    customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2">
    
    <template #contenido="{ items }">
      <template v-for="(panel, index) in items" :key="index">
        <PanelImagenMasAnchor 
          :data="panel"
        />
      </template>
    </template>
  </Carrusel>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import Carrusel from '~/components/Carruseles/Carrusel.vue'
import PanelImagenMasAnchor from '~/components/Paneles/PanelImagenMasAnchor.vue'

const props = defineProps({
  imagenesPromocionales: {
    type: Object,
    required: true
  }
})

const ClaseSlide = ref('w-full h-full relative')
const isMobile = ref(false)

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 768
}

onMounted(() => {
  checkIsMobile()
  window.addEventListener('resize', checkIsMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkIsMobile)
})
</script>